import React from 'react';
import { Route, Switch } from "react-router-dom";
import AuthRoute from '../session/AuthRoute';
import NotFound from '../error/NotFound';
import ConfigModule from './configModule/ConfigModule';
import ConfigDispensing from './configDispensing/ConfigDispensing';
import ConfigArea from './configArea/ConfigArea';
import ConfigUser from './configUser/ConfigUser';
import ConfigAuth from './configAuth/ConfigAuth';
import './Config.css';

const Config = () => {
  return (
    <div className="configContainer">
      <Switch>
        <AuthRoute
          exact
          path={["/config", "/config/module"]}
          render={props => <ConfigModule {...props} />}
          />
        <AuthRoute
          path="/config/dispensing"
          render={props => <ConfigDispensing {...props} />}
          />
        <AuthRoute
          path="/config/area"
          render={props => <ConfigArea {...props} />}
          />
        <AuthRoute
          path="/config/user"
          render={props => <ConfigUser {...props} />}
          />
        <AuthRoute
          path="/config/auth"
          render={props => <ConfigAuth {...props} />}
          />
        <Route render={NotFound} />
      </Switch>
    </div>
  )
}

export default Config;